(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9085,4421],{

/***/ 64673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BackgroundBannerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29260);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


var BackgroundBannerImage = function(param) {
    var _layout = param.layout, layout = _layout === void 0 ? "fill" : _layout, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _priority = param.priority, priority = _priority === void 0 ? true : _priority, className = param.className;
    // TODO: update blue_banner.svg to not be massive and refactor this component to use <BlueBanner /> instead.
    //       Current implementation clashes with loki visual regression testing - stopping us from using this component in our stories
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: className,
        src: "/blue_banner.svg",
        layout: layout,
        objectFit: objectFit,
        alt: alt,
        priority: priority
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundBannerImage);


/***/ }),

/***/ 44421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _BackgroundBannerImage__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _BackgroundBannerImage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64673);



/***/ }),

/***/ 19052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ CmsModuleList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





var SingleCoverComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8821).then(__webpack_require__.bind(__webpack_require__, 88821));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88821)
            ];
        }
    }
});
var ArticleSnippet = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8574), __webpack_require__.e(370)]).then(__webpack_require__.bind(__webpack_require__, 14649)).then(function(mod) {
        return mod.ArticleSnippet;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14649)
            ];
        }
    }
});
var CMSButton = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3877).then(__webpack_require__.bind(__webpack_require__, 33877)).then(function(mod) {
        return mod.CMSButton;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33877)
            ];
        }
    }
});
var CMSImageText = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(56)]).then(__webpack_require__.bind(__webpack_require__, 80056)).then(function(mod) {
        return mod.CMSImageText;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80056)
            ];
        }
    }
});
var CMSText = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(4725)]).then(__webpack_require__.bind(__webpack_require__, 4725)).then(function(mod) {
        return mod.CMSText;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4725)
            ];
        }
    }
});
var CMSVideoText = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(1889)]).then(__webpack_require__.bind(__webpack_require__, 91889)).then(function(mod) {
        return mod.CMSVideoText;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91889)
            ];
        }
    }
});
var GeneralImageSlider = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8574), __webpack_require__.e(3654)]).then(__webpack_require__.bind(__webpack_require__, 6655)).then(function(mod) {
        return mod.GeneralImageSlider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6655)
            ];
        }
    }
});
var FrequentlyAskedQuestions = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(7074)]).then(__webpack_require__.bind(__webpack_require__, 17074));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17074)
            ];
        }
    }
});
var CMSForm = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1399), __webpack_require__.e(807), __webpack_require__.e(9803), __webpack_require__.e(2283), __webpack_require__.e(7243), __webpack_require__.e(6323)]).then(__webpack_require__.bind(__webpack_require__, 31585)).then(function(mod) {
        return mod.CMSForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31585)
            ];
        }
    }
});
var JobSnippet = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3040).then(__webpack_require__.bind(__webpack_require__, 23040)).then(function(mod) {
        return mod.JobSnippet;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23040)
            ];
        }
    }
});
var Testimonial = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(9708)]).then(__webpack_require__.bind(__webpack_require__, 59708)).then(function(mod) {
        return mod.Testimonial;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59708)
            ];
        }
    }
});
var ModuleMap = {
    "text-collection": CMSText,
    "image-collection": CMSImageText,
    "cover-collection": SingleCoverComponent,
    "testimonial-collection": Testimonial,
    "faq-collection": FrequentlyAskedQuestions,
    "article-snippet-collection": ArticleSnippet,
    "general-image-slider": GeneralImageSlider,
    "video-collection": CMSVideoText,
    "job-snippet-collection": JobSnippet,
    "button-collection": CMSButton,
    "forms-collection": CMSForm
};
var renderFaqs = function(modules) {
    var questionAnswers = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = modules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (item.__component !== "faq-collection.faq-collection" || !item.faq_collections) {
                continue;
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = item.faq_collections[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var faq = _step1.value;
                    if (faq.answerPlainText) {
                        questionAnswers.push({
                            questionName: faq.question,
                            acceptedAnswerText: faq.answerPlainText
                        });
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return questionAnswers.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .FAQPageJsonLd */ .Mg, {
        mainEntity: questionAnswers
    }) : null;
};
var CmsModuleList = function(param) {
    var modules = param.modules;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            renderFaqs(modules),
            modules.map(function(module) {
                var moduleType = module.__component.split(".")[0];
                var Comp = ModuleMap[moduleType];
                var key = "".concat(module.id, "_").concat(module.__component);
                return Comp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, module), key) : null;
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CmsModuleList);


/***/ }),

/***/ 62184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DropdownList_DropdownList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(96394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 6 modules
var Select = __webpack_require__(66851);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./components/DropdownList/DropdownList.module.scss
var DropdownList_module = __webpack_require__(90402);
var DropdownList_module_default = /*#__PURE__*/__webpack_require__.n(DropdownList_module);
;// CONCATENATED MODULE: ./components/DropdownList/DropdownList.tsx





var DropdownList = function(param) {
    var id = param.id, label = param.label, value = param.value, testId = param.testId, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _tooltipMessage = param.tooltipMessage, tooltipMessage = _tooltipMessage === void 0 ? "" : _tooltipMessage, onChange = param.onChange, renderOptions = param.renderOptions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
        className: (DropdownList_module_default()).container,
        fullWidth: true,
        "data-testid": "select-container-".concat(id),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                id: "label-".concat(id),
                shrink: value !== undefined,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: tooltipMessage,
                interactive: !tooltipMessage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                    id: id,
                    labelId: "label-".concat(id),
                    value: value || "",
                    IconComponent: ExpandMore/* default */.Z,
                    onChange: onChange,
                    inputProps: {
                        "data-testid": testId
                    },
                    disabled: disabled,
                    children: renderOptions()
                })
            })
        ]
    });
};
/* harmony default export */ var DropdownList_DropdownList = (DropdownList);

;// CONCATENATED MODULE: ./components/DropdownList/index.tsx



/***/ }),

/***/ 70884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LocationSearchAutocomplete_LocationSearchAutocomplete; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/locationService.ts
var locationService = __webpack_require__(2589);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 3 modules
var Autocomplete = __webpack_require__(53437);
// EXTERNAL MODULE: ./components/LocationSearchAutocomplete/LocationSearchAutocomplete.module.scss
var LocationSearchAutocomplete_module = __webpack_require__(43188);
var LocationSearchAutocomplete_module_default = /*#__PURE__*/__webpack_require__.n(LocationSearchAutocomplete_module);
;// CONCATENATED MODULE: ./components/LocationSearchAutocomplete/LocationSearchAutocomplete.tsx













var LocationSearchAutocomplete = function(param) {
    var _selectedLocation = param.selectedLocation, selectedLocation = _selectedLocation === void 0 ? {
        name: ""
    } : _selectedLocation, onSelectedLocationChange = param.onSelectedLocationChange, _label = param.label, label = _label === void 0 ? "Country, State, or City" : _label, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Country, State, or City" : _placeholder;
    var ref = (0,react.useState)([]), locations = ref[0], setLocations = ref[1];
    var ref1 = (0,react.useState)(""), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,react.useState)(false), openOptions = ref2[0], setOpenOptions = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var onSearchTermChange = lodash_debounce_default()(function(term) {
        return setSearchTerm(term);
    }, 500);
    (0,react.useEffect)(function() {
        if (searchTerm.length >= 2) {
            setLocations([]);
            setLoading(true);
            setOpenOptions(true);
            var fetchLocations = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var data, mappedLocations;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,locationService/* searchLocation */.h)(searchTerm)
                                ];
                            case 1:
                                data = _state.sent();
                                mappedLocations = data.locations.map(function(loc, idx) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loc), {
                                        divider: idx === data.locations.length - 1
                                    });
                                }).concat(data.results);
                                setLocations(mappedLocations);
                                setLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchLocations() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchLocations().catch(function() {
                return setOpenOptions(false);
            });
        } else {
            setOpenOptions(false);
        }
    }, [
        searchTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
        value: selectedLocation,
        onChange: function(_event, value) {
            onSelectedLocationChange(value);
            setOpenOptions(false);
        },
        ListboxProps: {
            style: {
                maxHeight: 250,
                overflow: "auto"
            }
        },
        "data-testid": "location-search-autocomplete",
        options: locations,
        autoHighlight: true,
        filterOptions: function(options) {
            return options;
        },
        popupIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
        clearOnBlur: true,
        open: openOptions,
        loading: !locations.length && loading,
        loadingText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            display: "flex",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                m: "auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
            })
        }),
        noOptionsText: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-testid": "job-search-no-options",
            children: [
                "The location ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: searchTerm
                }),
                " cannot be found."
            ]
        }),
        getOptionLabel: function(option) {
            return option.name;
        },
        getOptionSelected: function(option, value) {
            return option.name === value.name;
        },
        renderOption: function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: option.divider ? (LocationSearchAutocomplete_module_default()).divider : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-testid": "".concat(option.name).concat(option.city ? option.city : ""),
                            children: option.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (LocationSearchAutocomplete_module_default()).locationSubTitle,
                            children: [
                                option.city,
                                option.state,
                                option.country
                            ].filter(function(val) {
                                return !!val;
                            }).join(", ")
                        })
                    ]
                })
            });
        },
        renderInput: function(params) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                placeholder: placeholder,
                label: label,
                inputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.inputProps), {
                    maxLength: 200,
                    "data-testid": "job-search-location-autocomplete-input"
                }),
                onFocus: function() {
                    setOpenOptions(false);
                    setSearchTerm("");
                },
                onChange: function(e) {
                    return onSearchTermChange(e.target.value);
                },
                onBlur: function() {
                    return setOpenOptions(false);
                }
            }));
        }
    });
};
/* harmony default export */ var LocationSearchAutocomplete_LocationSearchAutocomplete = (LocationSearchAutocomplete);

;// CONCATENATED MODULE: ./components/LocationSearchAutocomplete/index.tsx



/***/ }),

/***/ 82898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ ProfileBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/LandingHeaderV2/hooks/useUserDisplayInfo.ts
var useUserDisplayInfo = __webpack_require__(43707);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
;// CONCATENATED MODULE: ./assets/profileBannerDoctor.png
/* harmony default export */ var profileBannerDoctor = ({"src":"https://cdn.medrecruit.medworld.com/8ab9b7fc0ee58df5cc13af32458786e3385f32a8/_next/static/media/profileBannerDoctor.45cf171f.png","height":404,"width":410,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXESNl+ARiqlbVoEP6N/kLuXteoqVI1jRzqEd4WKXVMGTb89W5hNVHoDWNyqoKpsiL69qafZuKombd2DrvXBtsJxc4uLa2KHcnoXVbi3dE6VVjNja4sDUs6Mi6XE1Pdjl+twEBImAAAAFnRSTlMAGrrsaPz+DGW+08L4/P3++/z+/fBEyeUPCgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEFJREFUCJljYAABFhZ2MM0kLskNotmZpXhkQTQjlzQvHwMDA4cYq4S4MAMDA6cEGxu/AoghxiokLwKSkhGQExQFAESVAoQENAWMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./components/ProfileBanner/ProfileBanner.module.scss
var ProfileBanner_module = __webpack_require__(38948);
var ProfileBanner_module_default = /*#__PURE__*/__webpack_require__.n(ProfileBanner_module);
;// CONCATENATED MODULE: ./components/ProfileBanner/ProfileBanner.tsx














var ProfileBanner = function(param) {
    var cookieConsentOverwrite = param.cookieConsentOverwrite;
    var ref = (0,react.useState)(false), closed = ref[0], setClosed = ref[1];
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 768px)");
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var isUserLoggedIn = (0,useUserDisplayInfo/* useUserDisplayInfo */.l)().isUserLoggedIn;
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var consent = cookieConsentOverwrite !== null && cookieConsentOverwrite !== void 0 ? cookieConsentOverwrite : (0,build.getCookieConsentValue)();
    if (consent !== "true" || isUserLoggedIn) {
        return null;
    }
    var VariablePill = function() {
        return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Top rates,"
                }),
                " negotiated for you"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Competitive rates"
        });
    };
    var onBannerClose = function() {
        setClosed(true);
        track("Click", {
            action: "Close profile banner",
            "element text": "",
            "element type": "button"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ProfileBanner_module_default()).bannerContainer, closed && (ProfileBanner_module_default()).closed),
        role: "banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBanner_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: profileBannerDoctor,
                    priority: true,
                    alt: "",
                    "aria-hidden": true,
                    width: 200,
                    height: 200
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (ProfileBanner_module_default()).header,
                        children: "Finding your next job just got easier."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ProfileBanner_module_default()).subHeader,
                        children: "Register to access"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (ProfileBanner_module_default()).benefitsPillsList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Exclusive"
                                    }),
                                    " roles"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariablePill, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Jobs"
                                    }),
                                    " matched to you"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (ProfileBanner_module_default()).getStartedButton,
                variant: "contained",
                href: "".concat(profileUrl, "/sign-up"),
                onClick: function() {
                    return track("Click", {
                        action: "Profile banner - get started",
                        "element text": "Get started",
                        "element type": "button"
                    });
                },
                children: "Get started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                className: (ProfileBanner_module_default()).closeButton,
                onClick: onBannerClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ProfileBanner/index.ts



/***/ }),

/***/ 43162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ JobSearchBox_JobSearchBox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/DropdownList/index.tsx + 1 modules
var DropdownList = __webpack_require__(62184);
// EXTERNAL MODULE: ./components/LocationSearchAutocomplete/index.tsx + 1 modules
var LocationSearchAutocomplete = __webpack_require__(70884);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./modules/JobSearchBox/components/JobSearchForm/JobSearchForm.module.scss
var JobSearchForm_module = __webpack_require__(88072);
var JobSearchForm_module_default = /*#__PURE__*/__webpack_require__.n(JobSearchForm_module);
;// CONCATENATED MODULE: ./modules/JobSearchBox/components/JobSearchForm/JobSearchForm.tsx






var JobSearchForm = function(param) {
    var grade = param.grade, onGradeChange = param.onGradeChange, locationCoordinate = param.locationCoordinate, onLocationCoordinateChange = param.onLocationCoordinateChange, getGradeOptions = param.getGradeOptions, onSubmit = param.onSubmit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": "job-search-container",
        className: (JobSearchForm_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (JobSearchForm_module_default()).gridContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (JobSearchForm_module_default()).gridItemGrade,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownList/* default */.Z, {
                        id: "grade",
                        label: "I'm a...",
                        value: grade,
                        testId: "job-search-grade-input",
                        onChange: function(e) {
                            onGradeChange("" + e.target.value);
                        },
                        renderOptions: getGradeOptions
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (JobSearchForm_module_default()).gridItemLocation,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSearchAutocomplete/* default */.Z, {
                        selectedLocation: locationCoordinate,
                        onSelectedLocationChange: onLocationCoordinateChange,
                        label: "Looking for work in...",
                        placeholder: "Country, State, or City"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (JobSearchForm_module_default()).gridItemSubmit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        fullWidth: true,
                        type: "submit",
                        onClick: onSubmit,
                        color: "secondary",
                        size: "medium",
                        variant: "contained",
                        "data-testid": "job-search-submit",
                        children: "Search"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var JobSearchForm_JobSearchForm = (JobSearchForm);

// EXTERNAL MODULE: ./utils/jobListingHelper.ts
var jobListingHelper = __webpack_require__(92628);
// EXTERNAL MODULE: ./utils/jobSearchBoxOptions.tsx
var jobSearchBoxOptions = __webpack_require__(73208);
// EXTERNAL MODULE: ./utils/jobSearchCookies.tsx
var jobSearchCookies = __webpack_require__(80059);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./utils/useRequest.ts
var useRequest = __webpack_require__(87243);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./modules/JobSearchBox/components/JobSearchBox/JobSearchBox.tsx











var JobSearchBox = function() {
    var handleSubmit = function handleSubmit() {
        var ref, ref1, ref2;
        var lon = locationCoordinate === null || locationCoordinate === void 0 ? void 0 : (ref = locationCoordinate.position) === null || ref === void 0 ? void 0 : ref.lon.toString();
        var lat = locationCoordinate === null || locationCoordinate === void 0 ? void 0 : (ref1 = locationCoordinate.position) === null || ref1 === void 0 ? void 0 : ref1.lat.toString();
        var search = {
            grade: grade,
            location: locationCoordinate === null || locationCoordinate === void 0 ? void 0 : (ref2 = locationCoordinate.searchLocations) === null || ref2 === void 0 ? void 0 : ref2.join(";"),
            lon: lon,
            lat: lat,
            locationName: locationCoordinate === null || locationCoordinate === void 0 ? void 0 : locationCoordinate.name,
            radius: lat && lon ? jobSearchBoxOptions/* DEFAULT_RADIUS */.J_ : undefined,
            page: 1
        };
        if (grade) {
            (0,jobSearchCookies/* setGradeCookie */.r8)(grade);
        }
        if (locationCoordinate) {
            (0,jobSearchCookies/* setLocationCookie */.Hl)(locationCoordinate);
        }
        track("Job Search", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
            autocompleteLocationSelectedType: search.lon ? "specific" : "scheduler",
            autocompleteLocationRadius: null,
            jobSearchSimple: true
        }));
        return router.push((0,jobListingHelper/* generateJobListingsUrlObject */.hX)(search));
    };
    var getGradeOpts = function getGradeOpts() {
        return (0,jobSearchBoxOptions/* getGradeOptions */.mG)(grades);
    };
    var router = (0,next_router.useRouter)();
    var track = (0,useAnalytics/* useAnalytics */.z)();
    // grade list
    var ref = (0,react.useState)([
        {
            value: "Loading",
            key: "Loading"
        }, 
    ]), grades = ref[0], setGrades = ref[1];
    // form state
    var ref1 = (0,react.useState)(undefined), grade = ref1[0], setGrade = ref1[1];
    var ref2 = (0,react.useState)(null), locationCoordinate = ref2[0], setLocationCoordinate = ref2[1];
    // end of form state
    // fetch the list of grades on initial load
    (0,react.useEffect)(function() {
        (0,useRequest/* getJobGrades */.TI)().then(function(grades) {
            return setGrades(grades);
        }).catch(function() {
            return null;
        }); // the error get reported by makeRequestAndNoticeErrors, and we don't show any notification to the user
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobSearchForm_JobSearchForm, {
        grade: grade,
        onGradeChange: setGrade,
        locationCoordinate: locationCoordinate,
        onLocationCoordinateChange: setLocationCoordinate,
        onSubmit: handleSubmit,
        getGradeOptions: getGradeOpts
    });
};
/* harmony default export */ var JobSearchBox_JobSearchBox = (JobSearchBox);

;// CONCATENATED MODULE: ./modules/JobSearchBox/index.tsx



/***/ }),

/***/ 2589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ searchLocation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17673);




var api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    paramsSerializer: function(params) {
        return querystring__WEBPACK_IMPORTED_MODULE_1__.stringify(params);
    }
});
var searchLocation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(term) {
        var response, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        api.get("/api/locations", {
                            params: {
                                q: term
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 2:
                    error = _state.sent();
                    throw new Error("Failed to load locations", {
                        cause: error
                    });
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function searchLocation(term) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 73208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B5": function() { return /* binding */ getRadiusOptions; },
/* harmony export */   "HN": function() { return /* binding */ getSubSpecialityOptions; },
/* harmony export */   "J_": function() { return /* binding */ DEFAULT_RADIUS; },
/* harmony export */   "Lc": function() { return /* binding */ getSpecialityOptions; },
/* harmony export */   "Tu": function() { return /* binding */ getRootSpecialityOptions; },
/* harmony export */   "XG": function() { return /* binding */ MIN_PAY_RATES; },
/* harmony export */   "i$": function() { return /* binding */ DEFAULT_MIN_PAY_RATE_UNIT; },
/* harmony export */   "mG": function() { return /* binding */ getGradeOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85639);


var DEFAULT_RADIUS = "50";
var DISTANCES = [
    "25",
    "50",
    "75",
    "100",
    "150"
];
var radiusOptions = DISTANCES.map(function(radius) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        value: radius,
        children: [
            radius,
            " km"
        ]
    }, radius);
});
var getRadiusOptions = function() {
    return radiusOptions;
};
var getGradeOptions = function(grades) {
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: "None"
            })
        }, "none"), 
    ];
    if (grades) {
        grades.forEach(function(grade) {
            return grade && options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                value: grade.value,
                "data-testid": grade.key,
                children: grade.value
            }, grade.key));
        });
    }
    return options;
};
var getSpecialityOptions = function(selectedGrade, specialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: selectedGrade ? "None" : "Please select a grade"
            })
        }, "none"), 
    ];
    selectedGrade && specialities[selectedGrade] && ((ref = specialities[selectedGrade]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var getRootSpecialityOptions = function(selectedGrade, specialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: selectedGrade ? "None" : "Please select a grade"
            })
        }, "none"), 
    ];
    selectedGrade && specialities[selectedGrade] && ((ref = specialities[selectedGrade]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var getSubSpecialityOptions = function(speciality, subSpecialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: speciality ? "None" : "Please select a speciality"
            })
        }, "none"), 
    ];
    speciality && subSpecialities[speciality] && ((ref = subSpecialities[speciality]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var DEFAULT_MIN_PAY_RATE_UNIT = "Hourly";
var MIN_PAY_RATES = {
    Hourly: [
        "75",
        "100",
        "125",
        "200",
        "250",
        "300"
    ],
    Daily: [
        "500",
        "600",
        "700",
        "800",
        "900",
        "1000",
        "1250",
        "1500",
        "1750",
        "2000",
        "2500",
        "3000", 
    ]
};


/***/ }),

/***/ 80059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dy": function() { return /* binding */ getGradeCookie; },
/* harmony export */   "Hl": function() { return /* binding */ setLocationCookie; },
/* harmony export */   "Jz": function() { return /* binding */ getLocationCookie; },
/* harmony export */   "Me": function() { return /* binding */ setSpecialityCookie; },
/* harmony export */   "nj": function() { return /* binding */ getSpecialityCookie; },
/* harmony export */   "r8": function() { return /* binding */ setGradeCookie; },
/* harmony export */   "yD": function() { return /* binding */ mapJobSearchLocationCookieToPreferredWorkLocation; }
/* harmony export */ });
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);

var JOB_SEARCH_GRADE_COOKIE = "mr-job-search-grade";
var JOB_SEARCH_SPECIALITY_COOKIE = "mr-job-search-speciality";
var JOB_SEARCH_LOCATION_COOKIE = "mr-job-search-location";
var JOB_SEARCH_COOKIE_LIFE_IN_MS = 24 * 60 * 60 * 1000; // 24 hours
var getGradeCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_GRADE_COOKIE);
    if (value && typeof value === "string") {
        return value;
    }
    return null;
};
var setGradeCookie = function(grade) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_GRADE_COOKIE, grade, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var getSpecialityCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_SPECIALITY_COOKIE);
    if (value && typeof value === "string") {
        return value;
    }
    return null;
};
var setSpecialityCookie = function(speciality) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_SPECIALITY_COOKIE, speciality, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var getLocationCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_LOCATION_COOKIE);
    if (value && typeof value === "string") {
        var parsedValue;
        try {
            parsedValue = JSON.parse(value);
        } catch (_e) {
            return null;
        }
        if ((parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.name) && (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.country)) {
            return {
                name: parsedValue.name,
                state: parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.state,
                country: parsedValue.country
            };
        }
    }
    return null;
};
var setLocationCookie = function(locationCoordinate) {
    var value = JSON.stringify({
        name: locationCoordinate.name,
        state: locationCoordinate === null || locationCoordinate === void 0 ? void 0 : locationCoordinate.state,
        country: locationCoordinate.country
    });
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_LOCATION_COOKIE, value, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var mapJobSearchLocationCookieToPreferredWorkLocation = function(locationCookie) {
    if (!locationCookie) {
        return null;
    }
    // country level
    if (locationCookie.name === "New Zealand") {
        return {
            key: "New Zealand",
            value: "Anywhere in New Zealand"
        };
    }
    if (locationCookie.name === "Australia") {
        return {
            key: "Australia",
            value: "Anywhere in Australia"
        };
    }
    // NZ locations
    if (locationCookie.country === "New Zealand") {
        if (locationCookie.name === "South Island") {
            return {
                key: "South Island of New Zealand",
                value: "South Island of New Zealand"
            };
        }
        if (locationCookie.name === "North Island") {
            return {
                key: "North Island of New Zealand",
                value: "North Island of New Zealand"
            };
        }
        return {
            key: "New Zealand",
            value: "Anywhere in New Zealand"
        };
    }
    // AU locations
    if (locationCookie.country === "Australia") {
        if (locationCookie.name === "Victoria" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Victoria") {
            return {
                key: "Victoria Australia",
                value: "Victoria Australia"
            };
        }
        if (locationCookie.name === "New South Wales" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "New South Wales") {
            return {
                key: "New South Wales Australia",
                value: "New South Wales Australia"
            };
        }
        if (locationCookie.name === "Queensland" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Queensland") {
            return {
                key: "Queensland Australia",
                value: "Queensland Australia"
            };
        }
        if (locationCookie.name === "South Australia" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "South Australia") {
            return {
                key: "South Australia",
                value: "South Australia"
            };
        }
        if (locationCookie.name === "Australian Capital Territory" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Australian Capital Territory") {
            return {
                key: "Australian Capital Territory",
                value: "Australian Capital Territory"
            };
        }
        if (locationCookie.name === "Tasmania" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Tasmania") {
            return {
                key: "Tasmania Australia",
                value: "Tasmania Australia"
            };
        }
        if (locationCookie.name === "Western Australia" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Western Australia") {
            return {
                key: "Western Australia",
                value: "Western Australia"
            };
        }
        if (locationCookie.name === "Northern Territory" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Northern Territory") {
            return {
                key: "Northern Territory Australia",
                value: "Northern Territory Australia"
            };
        }
    }
    return null;
};


/***/ }),

/***/ 90402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownList_container__qnIXv"};

/***/ }),

/***/ 43188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"locationSubTitle":"LocationSearchAutocomplete_locationSubTitle__IKyaf","divider":"LocationSearchAutocomplete_divider__d4la1"};

/***/ }),

/***/ 38948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"ProfileBanner_bannerContainer__kQhdF","closed":"ProfileBanner_closed__qtWy_","imageContainer":"ProfileBanner_imageContainer__VFnDG","header":"ProfileBanner_header__oXcWU","subHeader":"ProfileBanner_subHeader__UqIrm","benefitsPillsList":"ProfileBanner_benefitsPillsList__YVD5X","closeButton":"ProfileBanner_closeButton__O17v8","getStartedButton":"ProfileBanner_getStartedButton__dMz_Q"};

/***/ }),

/***/ 88072:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobSearchForm_container__w0L3Z","gridContainer":"JobSearchForm_gridContainer__RGNeU","gridItemGrade":"JobSearchForm_gridItemGrade__GDipa","gridItemLocation":"JobSearchForm_gridItemLocation___fL8D","gridItemSubmit":"JobSearchForm_gridItemSubmit__JW_3E"};

/***/ })

}]);